import { Guest, NewGuest } from './types';

export class UnauthorizedError extends Error {
  constructor() {
    super('Nicht autorisiert');
    this.name = 'UnauthorizedError';
  }
}

async function readResponse<T>(response: Response): Promise<T> {
  if (response.status === 401) 
    throw new UnauthorizedError();
  
  if (!response.ok) {
    const body = await response.json().catch(() => null) as { error?: string } | null;
    throw new Error(body?.error || 'Die Anfrage ist fehlgeschlagen.');
  }
  return response.json() as Promise<T>;
}

export async function createSession(password: string): Promise<void> {
  const response = await fetch('/api/session', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  });
  await readResponse<{ ok: true }>(response);
}

export async function getGuests(signal?: AbortSignal): Promise<Guest[]> {
  const response = await fetch('/api/guests', { credentials: 'same-origin', signal });
  const body = await readResponse<{ guests: Guest[] }>(response);
  return body.guests;
}

export async function addGuest(guest: NewGuest): Promise<Guest> {
  const response = await fetch('/api/guests', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(guest),
  });
  const body = await readResponse<{ guest: Guest }>(response);
  return body.guest;
}
